/*  iceberg-ui  */
import { Icon } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { Box, Chip } from '@mui/material';

/* Shared */
import { FontSizes, LifecycleStatus } from 'application/Shared/Constants';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

/*  Components  */
import ObjectPicker from './Components/ObjectPicker';

const getLifecycleStages = ({ t }) => ({
    [LifecycleStatus.Unapproved]: (
        <Chip
            icon={
                <Box sx={{ lineHeight: 0 }}>
                    <Icon size={FontSizes[2]} src="Warning" />
                </Box>
            }
            sx={{
                '& .MuiChip-icon': {
                    color: 'lifecycleStages.icon.unapproved'
                },
                '& .MuiChip-label': {
                    paddingX: '8px',
                    paddingY: '2px'
                },
                backgroundColor: 'lifecycleStages.background.unapproved',
                border: '1px solid',
                borderColor: 'lifecycleStages.borderColor.unapproved',
                color: 'lifecycleStages.textColor.unapproved'
            }}
            size="small"
            label={t('Picker.lifecycle.unapproved')}
        />
    ),
    // eslint-disable-next-line sort-keys-fix/sort-keys-fix
    [LifecycleStatus.NotConfigured]: (
        <Chip
            icon={
                <Box sx={{ lineHeight: 0 }}>
                    <Icon size={FontSizes[2]} src="QuestionMark" />
                </Box>
            }
            sx={{
                '& .MuiChip-icon': {
                    color: 'lifecycleStages.icon.notConfigured'
                },
                '& .MuiChip-label': {
                    paddingX: '8px',
                    paddingY: '2px'
                },
                backgroundColor: 'lifecycleStages.background.notConfigured',
                border: '1px solid',
                borderColor: 'lifecycleStages.borderColor.notConfigured',
                color: 'lifecycleStages.textColor.notConfigured'
            }}
            size="small"
            label={t('Picker.lifecycle.not_configured')}
        />
    ),
    // eslint-disable-next-line sort-keys-fix/sort-keys-fix
    [LifecycleStatus.Evaluating]: (
        <Chip
            icon={
                <Box sx={{ lineHeight: 0 }}>
                    <Icon size={FontSizes[2]} src="SeverityInformational" />
                </Box>
            }
            sx={{
                '& .MuiChip-icon': {
                    color: 'lifecycleStages.icon.evaluating'
                },
                '& .MuiChip-label': {
                    color: 'lifecycleStages.textColor.evaluating',
                    paddingX: '8px',
                    paddingY: '2px'
                },
                backgroundColor: 'lifecycleStages.background.evaluating',
                border: '1px solid',
                borderColor: 'lifecycleStages.borderColor.evaluating',
                color: 'lifecycleStages.textColor.evaluating'
            }}
            size="small"
            label={t('Picker.lifecycle.evaluating')}
        />
    ),
    [LifecycleStatus.Implementing]: (
        <Chip
            icon={
                <Box sx={{ lineHeight: 0 }}>
                    <Icon size={FontSizes[2]} src="AddCircle" />
                </Box>
            }
            sx={{
                '& .MuiChip-icon': {
                    color: 'lifecycleStages.icon.implementing'
                },
                '& .MuiChip-label': {
                    paddingX: '8px',
                    paddingY: '2px'
                },
                backgroundColor: 'lifecycleStages.background.implementing',
                border: '1px solid',
                borderColor: 'lifecycleStages.borderColor.implementing',
                color: 'lifecycleStages.textColor.implementing'
            }}
            size="small"
            label={t('Picker.lifecycle.implementing')}
        />
    ),
    // eslint-disable-next-line sort-keys-fix/sort-keys-fix
    [LifecycleStatus.Approved]: (
        <Chip
            icon={
                <Box sx={{ lineHeight: 0 }}>
                    <Icon size={FontSizes[2]} src="Check" />
                </Box>
            }
            sx={{
                '& .MuiChip-icon': {
                    color: 'lifecycleStages.icon.approved'
                },
                '& .MuiChip-label': {
                    paddingX: '8px',
                    paddingY: '2px'
                },
                backgroundColor: 'lifecycleStages.background.approved',
                border: '1px solid',
                borderColor: 'lifecycleStages.borderColor.approved',
                color: 'lifecycleStages.textColor.approved'
            }}
            size="small"
            label={t('Picker.lifecycle.approved')}
        />
    ),
    [LifecycleStatus.Decommissioning]: (
        <Chip
            icon={
                <Box sx={{ lineHeight: 0 }}>
                    <Icon size={FontSizes[2]} src="SubtractCircle" />
                </Box>
            }
            sx={{
                '& .MuiChip-icon': {
                    color: 'lifecycleStages.icon.decommissioning'
                },
                '& .MuiChip-label': {
                    paddingX: '8px',
                    paddingY: '2px'
                },
                backgroundColor: 'lifecycleStages.background.decommissioning',
                border: '1px solid',
                borderColor: 'lifecycleStages.borderColor.decommissioning',
                color: 'lifecycleStages.textColor.decommissioning'
            }}
            size="small"
            label={t('Picker.lifecycle.decommissioning')}
        />
    ),
    // eslint-disable-next-line sort-keys-fix/sort-keys-fix
    [LifecycleStatus.Decommissioned]: (
        <Chip
            icon={
                <Box sx={{ lineHeight: 0 }}>
                    <Icon size={FontSizes[2]} src="CloseCircle" />
                </Box>
            }
            sx={{
                '& .MuiChip-icon': {
                    color: 'lifecycleStages.icon.decommissioned'
                },
                '& .MuiChip-label': {
                    paddingX: '8px',
                    paddingY: '2px'
                },
                backgroundColor: 'lifecycleStages.background.decommissioned',
                border: '1px solid',
                borderColor: 'lifecycleStages.borderColor.decommissioned',
                color: 'lifecycleStages.textColor.decommissioned'
            }}
            size="small"
            label={t('Picker.lifecycle.decommissioned')}
        />
    )
});

class StatusPicker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            objectPayload: []
        };
    }

    componentDidMount() {
        this.load();
    }

    load = () => {
        const { t } = this.props;
        const visualPayload = getLifecycleStages({ t });

        const statuses = [
            {
                display: t(`Picker.lifecycle.${LifecycleStatus.Unapproved}`),
                displayVisualOnly: visualPayload[LifecycleStatus.Unapproved],
                id: LifecycleStatus.Unapproved
            },
            {
                display: t('Picker.lifecycle.not_configured'),
                displayVisualOnly: visualPayload[LifecycleStatus.NotConfigured],
                id: LifecycleStatus.NotConfigured
            },
            {
                display: t(`Picker.lifecycle.${LifecycleStatus.Evaluating}`),
                displayVisualOnly: visualPayload[LifecycleStatus.Evaluating],
                id: LifecycleStatus.Evaluating
            },
            {
                display: t(`Picker.lifecycle.${LifecycleStatus.Implementing}`),
                displayVisualOnly: visualPayload[LifecycleStatus.Implementing],
                id: LifecycleStatus.Implementing
            },
            {
                display: t(`Picker.lifecycle.${LifecycleStatus.Approved}`),
                displayVisualOnly: visualPayload[LifecycleStatus.Approved],
                id: LifecycleStatus.Approved
            },
            {
                display: t(
                    `Picker.lifecycle.${LifecycleStatus.Decommissioning}`
                ),
                displayVisualOnly:
                    visualPayload[LifecycleStatus.Decommissioning],
                id: LifecycleStatus.Decommissioning
            },
            {
                display: t(
                    `Picker.lifecycle.${LifecycleStatus.Decommissioned}`
                ),
                displayVisualOnly:
                    visualPayload[LifecycleStatus.Decommissioned],
                id: LifecycleStatus.Decommissioned
            }
        ];

        this.setState({
            loaded: true,
            objectPayload: statuses,
            visualOnlyDefault: visualPayload.not_configured
        });
    };

    render() {
        const { t } = this.props;
        const { loaded, objectPayload, visualOnlyDefault } = this.state;

        if (!loaded) {
            return null;
        }

        return (
            <ObjectPicker
                {...this.props}
                disableClearable
                objectNameField="display"
                objectNameFieldVisualOnly="displayVisualOnly"
                objectPayload={objectPayload}
                title={t('Common.lifecycleStage')}
                visualOnlyDefault={visualOnlyDefault}
            />
        );
    }
}

export default withTranslation()(StatusPicker);
